const COURSE_TOKEN_KEY = 'tc_course_token';
const COURSE_DEVICE_KEY = 'tc_course_device';

export function getCourseToken() {
  return localStorage.getItem(COURSE_TOKEN_KEY) || '';
}

export function setCourseToken(token) {
  localStorage.setItem(COURSE_TOKEN_KEY, token);
}

export function clearCourseToken() {
  localStorage.removeItem(COURSE_TOKEN_KEY);
}

export function getCourseDeviceId() {
  let id = localStorage.getItem(COURSE_DEVICE_KEY);
  if (!id) {
    const random = crypto?.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(16).slice(2)}`;
    id = `web-${random}`;
    localStorage.setItem(COURSE_DEVICE_KEY, id);
  }
  return id;
}

export async function courseLogout() {
  const token = getCourseToken();
  await fetch('/api/course/auth/logout', {
    method: 'POST',
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  }).catch(() => {});
  clearCourseToken();
}

function authHeaders() {
  const token = getCourseToken();
  const headers = { 'x-device-fingerprint': getCourseDeviceId() };
  if (token) headers.Authorization = `Bearer ${token}`;
  return headers;
}
async function readJsonResponse(response, fallbackMessage) {
  const data = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(data.error || fallbackMessage);
  return data;
}

export async function courseLogin({ orgCode, phone }) {
  const response = await fetch('/api/course/auth/login', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ orgCode, phone, deviceFingerprint: getCourseDeviceId() }),
  });
  const data = await readJsonResponse(response, '登录失败');
  setCourseToken(data.token);
  return data;
}

export async function fetchCourseList() {
  const response = await fetch('/api/course/list', {
    headers: authHeaders(),
    cache: 'no-store',
  });
  return readJsonResponse(response, '获取课程列表失败');
}

export async function fetchCourseContent(courseId) {
  const response = await fetch(`/api/course/${encodeURIComponent(courseId)}/content`, {
    headers: authHeaders(),
    cache: 'no-store',
  });
  return readJsonResponse(response, '获取课程内容失败');
}

export async function bindDevice({ serialNumber, courseId }) {
  const response = await fetch('/api/device/bind', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...authHeaders() },
    body: JSON.stringify({ serialNumber, courseId }),
  });
  return readJsonResponse(response, '设备绑定失败');
}

export async function uploadCourseware({ file, title, description }) {
  const form = new FormData();
  form.append('file', file);
  form.append('title', title || file.name.replace(/\.html?$/i, ''));
  form.append('description', description || '网页形式互动课件');

  const response = await fetch('/api/courseware/upload', {
    method: 'POST',
    headers: authHeaders(),
    body: form,
  });
  return readJsonResponse(response, '上传课件失败');
}

export function getCoursewareUrl(courseId, entryPath = '') {
  const encodedCourseId = encodeURIComponent(courseId);
  const normalizedEntry = String(entryPath || '').replace(/^\/+/, '');
  const encodedEntry = normalizedEntry
    .split('/')
    .filter(Boolean)
    .map((part) => encodeURIComponent(part))
    .join('/');
  return encodedEntry ? `/api/course/${encodedCourseId}/courseware/${encodedEntry}` : `/api/course/${encodedCourseId}/courseware`;
}
export function getCoursewarePlayerUrl(courseId) {
  return `/api/course/${encodeURIComponent(courseId)}/player`;
}